import type { OutputLayer } from '@/components/preview/output-layer-preview';

/** MUI `theme.zIndex.modal` is 1300 — keep slide chrome below that. */
export const PREVIEW_SLIDE_OVERLAY_Z_INDEX_CAP = 1299;

/** Above playState `layerId` tiles (media-agent infra is often ~251). */
export function resolvePreviewSlideOverlayZIndex(layers: OutputLayer[]): number {
  const maxLayerId = layers.reduce((max, layer) => Math.max(max, layer.layerId), 0);
  return Math.min(maxLayerId + 1, PREVIEW_SLIDE_OVERLAY_Z_INDEX_CAP);
}
